function i() {
  return {
    dispatchEvent: (n, t) => {
      typeof window > "u" || window.dispatchEvent(new CustomEvent(n, {
        detail: t
      }));
    }
  };
}
export {
  i as useWindowEvent
};
//# sourceMappingURL=useWindowEvent.js.map
